<template>
  <div class="wechat-pay-card-outer">
    <div v-if="showQrCode" id="pay_wechat_div">
    </div>

    <div v-else class="jsapi-button-outer">
      <el-button round @click="payButtonClicked">点击支付</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WechatPayCard",
  props: [
    'payModel'
  ],
  data() {
    return {
      showQrCode: true,
      checkInterval: null,
    }
  },
  watch: {
    payModel(newVal, oldVal) {
      this.dealWithPayCodeImg();
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    }
  },
  mounted() {
    this.showQrCode = this.isPc();
    this.dealWithPayCodeImg();
  },
  methods: {
    dealWithPayCodeImg() {
      if (this.payModel != undefined || this.payModel != null) {
        if (!this.showQrCode) {
          return;
        }
        let url = this.payModel.codeUrl;
        url = encodeURI(url);
        $('#pay_wechat_div').qrcode({
          render: 'canvas',
          text: url,
          width: '200',
          height: '200',
          background: '#ffffff',
          foreground: '#000000',
          src: '',
        });
      }
    },

    payButtonClicked() {
      this.$emit('payClicked');
    }
  }
}
</script>

<style scoped>

  .wechat-pay-card-outer {
    width: 200px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .wechat-pay-card-outer #pay_wechat_div {
    width: 100%;
    height: 200px;
  }

  .wechat-pay-card-outer .jsapi-button-outer {
    width: 100%;
    height: 200px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }

  .jsapi-button-outer .el-button {
    background-color: #fc1a34;
    color: white;
    border-color: transparent;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/WechatPayCard.vue